import React, { useEffect } from 'react';
import { ActivitiesCountries, CountriesActivites } from '../../interface/Back';
import { useAppDispatch, useAppSelector } from '../../Hooks';
import { getAllActivities } from '../../redux/Actions';
import { F_O } from '../../redux/Action_Types';
import { EvenSelect } from '../../types/Functions';

export const FilterOrder = (
  { OrderName, OrderPopulation, FilterContinent, FilterActivity, }: 
  { OrderName: EvenSelect, OrderPopulation: EvenSelect, FilterContinent: EvenSelect, FilterActivity: EvenSelect }
) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch<any>(getAllActivities());
  }, [dispatch]);

  let { copyCountries, activities } = useAppSelector(state => state);

  let filterContinent: CountriesActivites[] = [];
  filterContinent = copyCountries.reduce((acc: CountriesActivites[], el: CountriesActivites) => {
    if (!acc.find((c: CountriesActivites) => c.continents === el.continents)) {
      acc.push(el);
    }
    return acc;
  }, []);
  
  let filterActivity: ActivitiesCountries[] = [];
  filterActivity = activities.reduce((acc: ActivitiesCountries[], el: ActivitiesCountries) => {
    if (!acc.find((c: ActivitiesCountries) => c.name === el.name)) {
      acc.push(el);
    }
    return acc;
  }, []);

  return (
    <div className='filter__container' >
      <select
        onChange={(e) => FilterContinent(e)}
        className='filter__container--continent'
      >
        <option value={F_O.ALL}>All Continents</option>
        {filterContinent.map((el: CountriesActivites) => {
          return <optgroup key={el.area} >
            <option>{el.continents}</option>
          </optgroup>;
        })}
      </select>

      <select
        onChange={(e) => FilterActivity(e)}
        className='filter__container--activity'
      >
        <option value={F_O.ALL}>All Activities</option>
        {filterActivity.map((el: ActivitiesCountries) => {
          return <optgroup key={el.id} >
            <option>{el.name}</option>
          </optgroup>;
        })}
      </select>

      <select
        onChange={(e) => OrderName(e)}
        className='filter__container--name'
      >
        <option>Order by Name</option>
        <option value={F_O.ASC}>A - Z</option>
        <option value={F_O.DESC}>Z - A</option>
      </select>
      
      <select
        onChange={(e) => OrderPopulation(e)}
        className='filter__container--population'
      >
        <option>All Population</option>
        <option value={F_O.Mayor_Poblacion}>High Population</option>
        <option value={F_O.Menor_Poblacion}>Low Population</option>
      </select>
    </div>
  )
}
